(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    // Keep native details semantics and animate both directions, including rapid clicks.
    root.querySelectorAll('.faq details').forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      let animation = null;
      let expanded = details.open;
      summary.addEventListener('click', event => {
        if (event.target.closest('a, button, input, select, textarea')) return;
        event.preventDefault();
        expanded = !expanded;
        const from = details.getBoundingClientRect().height;
        if (animation) { animation.cancel(); animation = null; }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
          details.open = expanded;
          details.style.overflow = '';
          return;
        }
        // Measure natural heights with the same borders and wrapping as the final state.
        details.open = expanded;
        const to = details.getBoundingClientRect().height;
        details.open = true;
        details.style.overflow = 'hidden';
        animation = details.animate(
          [{height: `${from}px`}, {height: `${to}px`}],
          {duration: 240, easing: 'cubic-bezier(.25,.1,.25,1)'}
        );
        animation.onfinish = () => {
          details.open = expanded;
          details.style.overflow = '';
          animation = null;
        };
      });
    });
    const ref = name => root.querySelector(`[data-ref="${name}"]`);
    const norm = text => String(text).normalize('NFKC').toLowerCase().trim();
    const products = [...root.querySelectorAll('[data-product]')].map(el => ({el, name:el.dataset.name, handle:el.dataset.handle,
      sizes:[...el.querySelector('[data-sizes]').content.querySelectorAll('span')].map(el=>el.textContent),
      rows:[...el.querySelectorAll('[data-row]')]}));
    const aliases = [...root.querySelector('[data-aliases]').content.childNodes].map(node=>node.textContent||'').join('').split('\n').map(line => line.split('=').map(norm)).filter(pair=>pair.length===2 && pair[0]);
    const keyword=ref('keyword'), select=ref('product-select'), chips=ref('sizes');
    let selected='';
    const preferred=['XXS','XS','S','SM','M','ML','L','XL','XXL'];
    const available=[...new Set(products.flatMap(p=>p.sizes))];
    const sizes=[...preferred.filter(s=>available.includes(s)),...available.filter(s=>!preferred.includes(s))];
    for (const p of products) { const option=document.createElement('option');option.value=p.handle;option.textContent=p.name;select.append(option); }
    for (const size of ['',...sizes]) { const button=document.createElement('button');button.type='button';button.className='chip';button.dataset.size=size;button.textContent=size||'すべて';chips.append(button); }
    function filter() {
      const active=products.find(p=>p.handle===select.value);
      if(active && selected && !active.sizes.includes(selected)) selected='';
      for(const button of chips.children) { button.disabled=!!(active && button.dataset.size && !active.sizes.includes(button.dataset.size));button.setAttribute('aria-pressed',String(selected===button.dataset.size)); }
      const tokens=norm(keyword.value).split(/\s+/).filter(Boolean);let count=0,groups=0;
      for(const p of products) {
        let visible=0;
        for(const row of p.rows) {
          let text=norm([p.name,row.dataset.color,row.dataset.variant].join(' '));
          text+=' '+aliases.filter(([key])=>text.includes(key)).map(([,value])=>value).join(' ');
          const match=(!select.value||select.value===p.handle)&&(!selected||row.dataset.size===selected)&&tokens.every(t=>sizes.some(s=>norm(s)===t)?norm(row.dataset.size)===t:text.includes(t));
          row.hidden=!match;if(match)visible++;
        }
        p.el.hidden=!visible;p.el.querySelector('[data-row-count]').textContent=`${visible} 件`;
        if(visible){groups++;count+=visible;if(tokens.length||selected||select.value)p.el.open=true;}
      }
      ref('result-count').textContent=`${groups} 商品 / ${count} 件`;
      ref('empty').hidden=count>0||products.length===0;
    }
    function reset(){keyword.value='';select.value='';selected='';filter();}
    keyword.addEventListener('input',filter);select.addEventListener('change',filter);
    chips.addEventListener('click',event=>{const button=event.target.closest('button[data-size]');if(button&&!button.disabled){selected=button.dataset.size;filter();}});
    ref('reset').addEventListener('click',reset);ref('empty-reset').addEventListener('click',()=>{reset();keyword.focus();});
    root.querySelector('.filters').hidden=products.length===0;ref('reset').hidden=products.length===0;
    function followHash(){let handle;try{handle=decodeURIComponent(location.hash.slice(1));}catch{return;}const p=products.find(p=>p.handle===handle);if(p){reset();p.el.open=true;p.el.scrollIntoView({block:'start'});}}
    filter();followHash();
    window.addEventListener('hashchange',followHash);
    const unload=event=>{if(event.target.contains(root)){window.removeEventListener('hashchange',followHash);document.removeEventListener('shopify:section:unload',unload);}};
    document.addEventListener('shopify:section:unload',unload);
  }
  const initialize=()=>document.querySelectorAll('[data-restock-root]').forEach(init);
  initialize();document.addEventListener('shopify:section:load',initialize);
})();
